import { Context, Dispatch, useContext } from "react";

/**
 * Create a dispatch hook
 */
export const createDispatchHook = <A>(
  dispatchContext: Context<Dispatch<A> | undefined>
) => {
  return (): Dispatch<A> => {
    const dispatch = useContext(dispatchContext);
    if (dispatch === undefined) {
      throw new Error("useDispatch must be used within a Provider");
    }

    return dispatch;
  };
};
